import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Empty from '../../components/Display/Empty'
import Modal from '../../components/Display/Modal'
import {
  cleanTransactions,
  fectchAccounts,
  fetchTransactions,
  setBalance,
} from '../../redux/actions/accounts'
import { fetchBanks } from '../../redux/actions/banks'
import { fetchCurrencies } from '../../redux/actions/currencies'
import { RootState } from '../../redux/store'
import AccountCard from './AccountCard'
import CreateAccountForm from './CreateAccountForm'
import ClientAnimation from '../../assets/animations/client_animation.json'
import { ColumnsTable, HeaderActions, IMoneyAccount } from 'safe'
import BalancesForm from './BalancesForm'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import {
  formatPipe,
  formatter,
  getDenomination,
  getYearMonthAndDay,
  transformDate,
} from '../../utils/utils'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import Button from '../../components/General/Button'
import { FaArrowLeft } from 'react-icons/fa'
import EmptyBox from '../../assets/animations/empty_box.json'
import FloatingForm from '../../components/Display/FloatingForm'
import axios from 'axios'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import AdvancedIncomeForm from '../../components/Display/AdvancedIncomeForm'
import { DateTime } from 'luxon'
import Select from '../../components/Inputs/Select'
// import Income from '../Finances/IncomeForm'
import IncomeForm from '../Finances/IncomeForm'
import FloatingMenu from '../../components/Display/FloatingMenu'
import { HiDotsVertical, HiOutlinePlus } from 'react-icons/hi'
import ModalConfirm from '../../components/Display/ModalConfirm'

const server = process.env.REACT_APP_SERVER_URL
const Balances: React.FC<BalancesProps> = ({ setHeaderActions }) => {
  const dispatch = useDispatch()
  const [formAccountModal, setFormAccountModal] = useState<boolean>(false)
  const [modalSelectAction, setModalSelectAction] = useState<boolean>(false)
  const banks = useSelector((state: RootState) => state.bank.banks)
  const currencies = useSelector((state: RootState) => state.curr.currencies)
  const accounts = useSelector((state: RootState) => state.acct.accounts)
  // const transactions = useSelector(
  //   (state: RootState) => state.acct.transactions
  // )
  // const [transactions, setTransactions] = useState<any[]>([])
  const { addAlert } = useSnackBars()

  // const numberOfPages = useSelector(
  //   (state: RootState) => state.acct.numberOfPages
  // )
  const [selectedAccount, setSelectedAccount] = useState<IMoneyAccount | null>(
    null
  )
  // const [currentPage, setCurrentPage] = useState<number>(0)
  // const [loading, setLoading] = useState<boolean>(false)
  const [userConfig] = useLocalStorageState('user-config')
  const [
    selectedAccountToTransactions,
    setSelectedAccountToTransactions,
  ] = useState<IMoneyAccount | null>(null)
  const [showModal, setShowModal] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useState<string[]>([])
  const [showModalAdd, setShowModalAdd] = useState<boolean>(false)
  const [menuVisible, setMenuVisible] = useState<any>()
  const [transacionToDelete, setTransacionToDelete] = useState<any | null>(null)
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)

  const [transactionsInfo, setTransactionsInfo] = useState({
    transactions: [],
    numberOfPages: 0,
    currentPage: 0,
    loading: false,
  })

  const options = [
    { text: 'Ingreso', value: 'INCOME' },
    { text: 'Egreso', value: 'OUTFLOW' },
  ]

  const [selectedType, setSelectedType] = useState<'INCOME' | 'OUTFLOW'>(
    'INCOME'
  )

  const { transactions, numberOfPages, currentPage, loading } = transactionsInfo

  const [reconcileToAdd, setReconcileToAdd] = useState<any[]>([])

  const [originalArray, setOriginalArray] = useState<any[]>([])

  const [onShowMovementAction, setOnShowMovementAction] = useState<boolean>(
    false
  )

  let objTransform = {
    'MOBILE PAYMENT': 'Pago Móvil',
    'WIRE TRANSFER': 'Transferencia Bancaria',
    CASH: 'Efectivo',
    CARD: 'Tarjeta de débito',
    WALLET: 'Billetera Virtual',
    FREELY: 'Arbitrario',
    REFUND: 'Devolución',
    CREDIT: 'Crédito',
  }

  const columns: ColumnsTable[] = [
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {transformDate(record?.date)}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Cantidad',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {`${
            selectedAccountToTransactions?.idCurrency &&
            getDenomination(selectedAccountToTransactions?.idCurrency)
          } ${formatPipe(record.amount)}`}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Referencia',
      dataIndex: 'reference',
      key: 'reference',
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${record?.description ? '' : 'text-gray-600'}`}
        >
          {record?.description || 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${
            record?.type === 'income' ? 'text-primaryGreen-500' : 'text-red-700'
          }`}
        >
          {record?.type === 'income' ? 'Entrada' : 'Salida'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Usuario',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Conciliado',
      dataIndex: 'reconciled',
      key: 'reconciled',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {record?.reconciled ? 'Conciliado' : 'No Conciliado'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, record: any) => (
        <ColumnItemWrapper floatingMenu>
          {/* <div className="text-gray-500 relative"> */}
          <FloatingMenu
            visible={menuVisible === `${record?.type}-${record?.id}`}
            onClose={() => {
              setMenuVisible(-1)
            }}
            options={{
              onDelete: () => {
                setTransacionToDelete(record)
                setShowConfirmModal(true)
              },
            }}
          >
            <HiDotsVertical
              className="cursor-pointer dark:text-white text-primaryGray-400"
              onClick={() => {
                setMenuVisible(`${record?.type}-${record?.id}`)
                // setEdit(record)
                // setModal(true)
              }}
            />
          </FloatingMenu>
        </ColumnItemWrapper>
      ),
    },
  ]

  useEffect(() => {
    dispatch(fetchBanks())
    dispatch(fetchCurrencies())
    dispatch(fectchAccounts())
    return () => {
      setHeaderActions(null)
      dispatch(cleanTransactions())
    }
  }, [])

  const getTransactions = async () => {
    // setLoading(true)
    try {
      if (selectedAccountToTransactions)
        await dispatch(
          fetchTransactions(selectedAccountToTransactions?.id, searchParams, [
            `pageNumber=${currentPage + 1}`,
            `pageSize=${userConfig.rowsPerPage}`,
          ])
        )
    } catch (err) {
    } finally {
      // setLoading(false)
    }
  }

  // useEffect(() => {
  //   // if (transactions.length !== 0) {
  //     getTransactions()
  //   // }
  // }, [currentPage])

  const filterActions = (values: any) => {
    let originalFilter = originalArray.filter(
      (v) => !reconcileToAdd.some((x) => x.id === v.id)
    )
    let reconcileFilter = reconcileToAdd.filter(
      (v) => !originalArray.some((x) => x.id === v.id)
    )

    console.log('original filter', originalFilter)
    console.log('reconcile', reconcileFilter)

    if ([...originalFilter, ...reconcileFilter].length === 0) {
      // if (transactions.length === 0) {
      //   const { advancedSearch, onChangeReconcile, ...rest } = values
      //   return rest
      // }

      if (!selectedAccountToTransactions) {
        const { onChangeReconcile, advancedSearch, ...rest } = values
        return rest
      }

      const { onChangeReconcile, addAction, ...rest } = values
      return rest
    }

    if (!selectedAccountToTransactions) {
      const { advancedSearch, ...rest } = values
      return rest
    }

    if (selectedAccountToTransactions) {
      const { addAction, ...rest } = values
      return rest
    }

    return values
    // if (selectedAccountToTransactions) {
    //   return values
    // }
    // const { searchAction, ...rest } = values
    // return rest
  }

  useEffect(() => {
    setHeaderActions(
      filterActions({
        onChangeReconcile: async () => {
          let originalFilter = originalArray.filter(
            (v) => !reconcileToAdd.some((x) => x.id === v.id)
          )
          let reconcileFilter = reconcileToAdd.filter(
            (v) => !originalArray.some((x) => x.id === v.id)
          )

          let joinedArray = [...originalFilter, ...reconcileFilter]

          try {
            await Promise.all(
              joinedArray.map(async (v) => {
                let body = {
                  id: v?.id?.split('-')[1],
                  type: v?.type,
                  reconciled: !v.reconciled,
                }
                return await axios.patch(
                  `${server}/finances/account/reconcile`,
                  body
                )
              })
            )

            onGetMovements([], 0)

            addAlert({
              message: 'Conciliaciones realizadas satisfactoriamente',
              status: 'success',
            })
          } catch (err) {
            addAlert({
              message: 'Error al realizar alguna conciliación',
              status: 'error',
            })
          }
        },
        addAction: () => {
          if (selectedAccountToTransactions) {
            setModalSelectAction(true)
          } else {
            setFormAccountModal(true)
          }
        },
        // searchAction: () => setShowModal(true),
        advancedSearch: (value) => {
          if (typeof value === 'boolean') {
            // setModalSearch(true)
            setShowModal(true)
            return
          }
          // setSearchParams([`fastSearch=${value}`])
          onGetMovements([`fastSearch=${value}`], 0)
        },
        cleanFilters: {
          sort: () => {
            console.log('sort clean')
          },
          search: async () => {
            onGetMovements([], 0)
            // setSearchParams([])
            // if (currentPage === 0) {
            //   // setLoading(true)
            //   if (selectedAccountToTransactions)
            //     await dispatch(
            //       fetchTransactions(
            //         selectedAccountToTransactions.id,
            //         [],
            //         [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
            //       )
            //     )
            //   // setLoading(false)
            // }
            // // setCurrentPage(0)
          },
          isSearch: Boolean(searchParams.length > 0),
        },
      })
    )
  }, [
    // transactions,
    setHeaderActions,
    searchParams,
    currentPage,
    selectedAccountToTransactions,
    reconcileToAdd,
    originalArray,
    transactions,
  ])

  const onUpdateAccount = async (accountValues: any): Promise<void> => {
    try {
      dispatch(
        setBalance({
          ...accountValues,
          idAccount: selectedAccount?.id,
          details: 'FREELY',
        })
      )
    } catch (err) {
    } finally {
      setSelectedAccount(null)
    }
  }

  const onGetMovements = async (
    querySearch: string[] = searchParams,
    page: number = currentPage,
    account: any = selectedAccountToTransactions
  ) => {
    setSelectedAccountToTransactions(account)
    // setLoading(true)
    let paginationParams: string[] = [
      `pageNumber=${page + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]
    setTransactionsInfo((prevState) => ({
      ...prevState,
      loading: true,
    }))

    try {
      let response = await axios.get(
        `${server}/finances/account/record?idAccount=${account.id}&${[
          ...paginationParams,
          ...querySearch,
        ].join('&')}`
      )
      setTransactionsInfo((prevState) => ({
        ...prevState,
        transactions: response?.data?.records.map((record) => ({
          ...record,
          id: `${record?.type}-${record?.id}`,
        })),
        numberOfPages: +response?.data?.numberOfPages || 0,
        currentPage: page,
        loading: false,
      }))

      let reconciles = response.data.records.reduce((a, b) => {
        if (b.reconciled) {
          return [
            ...a,
            {
              ...b,
              id: `${b?.type}-${b?.id}`,
            },
          ]
        }
        return a
      }, [])

      setReconcileToAdd(reconciles)

      setOriginalArray(reconciles)
    } catch (err) {
      addAlert({
        message: 'Error al obtener las transacciones',
        status: 'error',
      })
    }
  }

  const onSubmitValues = async (values) => {
    let params: string[] = []

    if (values.type === 'receipt') {
      params = [`receipt=${values.invoiceNumber}`]
      setSearchParams([`receipt=${values.invoiceNumber}`])
    } else {
      const [yearFrom, monthFrom, dayFrom] = getYearMonthAndDay(values.from)
      // const fromDate = new Date(year, month, day);
      values.from = new Date(yearFrom, monthFrom, dayFrom)

      const [yearTo, monthTo, dayTo] = getYearMonthAndDay(values.to)

      values.to = new Date(yearTo, monthTo, dayTo + 1)

      values.from = values.from.toISOString()

      values.to = values.to.toISOString()

      params = Object.keys(values).map((key) => `${key}=${values[key]}`)

      setSearchParams(params)
    }

    // setCurrentPage(0)
    if (currentPage === 0) {
      // setLoading(true)
      if (selectedAccountToTransactions)
        await dispatch(
          fetchTransactions(
            selectedAccountToTransactions && selectedAccountToTransactions.id,
            params,
            [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
          )
        )
      // setLoading(false)
    }
    /* Peticion aca */
    setShowModal(false)
  }

  return (
    <div>
      {selectedAccountToTransactions && (
        <div className="flex-row flex justify-between mb-3">
          <div className="flex space-x-2 mt-3 px-1 block">
            <Button
              classes="border-none"
              onClick={() => {
                setSearchParams([])
                setReconcileToAdd([])
                setOriginalArray([])
                setSelectedAccountToTransactions(null)
                setTransactionsInfo({
                  transactions: [],
                  numberOfPages: 0,
                  currentPage: 0,
                  loading: false,
                })
                // setSearchParams([])
                // // setCurrentPage(0)
                // setSelectedAccountToTransactions(null)
                // dispatch(cleanTransactions())
              }}
              type="arrow"
              warehouseType="SALE FLOOR"
            >
              <FaArrowLeft size={30} />
            </Button>

            <h1 className="dark:text-primaryGreen-300 text-primaryGreen-500">
              {selectedAccountToTransactions?.description}
            </h1>
          </div>
          <Button
            type="primary"
            icon={<HiOutlinePlus />}
            onClick={() => {
              console.log('selected account', selectedAccountToTransactions)
              setOnShowMovementAction(true)
            }}
          >
            Añadir Movimiento
          </Button>
        </div>
      )}

      {!selectedAccountToTransactions && (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 px-1">
          {accounts.map((account) => (
            <AccountCard
              account={account}
              onEdit={() => setSelectedAccount(account)}
              onPressCardProp={() => onGetMovements([], 0, account)}
              key={account?.id}
              banks={banks}
            />
          ))}
        </div>
      )}

      {transactions.length === 0 && selectedAccountToTransactions && (
        <Empty
          animationProps={{
            height: 200,
            width: 200,
            animation: EmptyBox,
          }}
          lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
        >
          <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
            No hay movimientos
          </p>
        </Empty>
      )}

      {transactions.length > 0 && selectedAccountToTransactions && (
        <Table
          data={transactions}
          columns={columns}
          pages={numberOfPages}
          pageSelected={currentPage}
          loading={loading}
          setPageSelected={(page) => onGetMovements(searchParams, page)}
          isArraySelectable={true}
          selectedData={reconcileToAdd}
          setSelectedData={(data) => {
            // let values = [...data, {...data[0], edited: true}]
            // console.log("data...", values)
            setReconcileToAdd(data)
            // setBillsToPayToAdd(data)
          }}

          // setLoading={setLoading}
        />
      )}

      {accounts.length === 0 && (
        <Empty
          animationProps={{
            height: 400,
            width: 400,
            animation: ClientAnimation,
          }}
          lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
        >
          <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
            Añade cuentas y comienza a llevar el mejor control de tus finanzas
          </p>
        </Empty>
      )}
      <Modal
        display={formAccountModal}
        // modalClasses="w-3/6 py-4 px-12"
        // xlClasses="xl:w-96"
        contentStyle={{width: 900}}
        onClose={() => {
          setFormAccountModal(false)
        }}
        scroll="scroll"
      >
        <CreateAccountForm
          onCancel={() => {
            setFormAccountModal(false)
          }}
          banks={banks}
          currencies={currencies}
          accounts={accounts}
        />
      </Modal>

      {/* <ModalSearchHistoric
        display={showModal}
        onClose={() => setShowModal(false)}
        onSubmitValues={onSubmitValues}
        type="BALANCE"
      /> */}

      <Modal
        display={selectedAccount !== null}
        onClose={() => setSelectedAccount(null)}
      >
        <>
          <BalancesForm
            onCancel={() => setSelectedAccount(null)}
            defaultValues={{}}
            onSubmitBalance={(v) => onUpdateAccount(v)}
          />
        </>
      </Modal>

      <FloatingForm
        visible={showModal}
        onClose={() => setShowModal(false)}
        topClass="top-20"
        rightClass="right-10"
        containerClass="w-2/6"
      >
        {/* <BalancesForm
            onCancel={() => setSelectedAccount(null)}
            defaultValues={{}}
            onSubmitBalance={(v) => onUpdateAccount(v)}
        /> */}
        {/* <FloatingHistoricSearch onClose={() => setShowModal(false)} onSubmitValues={onSubmitValues} /> */}
        <AdvancedIncomeForm
          onClose={() => setShowModal(false)}
          onSubmit={async (values) => {
            if (values.isDateSelected) {
              const [yearFrom, monthFrom, dayFrom] = getYearMonthAndDay(
                values.fromDate
              )
              const [yearTo, monthTo, dayTo] = getYearMonthAndDay(values.toDate)
              let from = new Date(yearFrom, monthFrom, dayFrom)
              let to = new Date(yearTo, monthTo, dayTo + 1)

              let dateFrom = DateTime.fromISO(from.toISOString()).toISODate()
              let datePrueba = DateTime.fromISO(to.toISOString()).toISODate()
              console.log('date prueba...', datePrueba)

              // let newTo = to.toISOString()
              // console.log("NEW", newTo.replace(/T.+/, '').replace(/\-/g, "/"))
              // console.log("TO", to.toLocaleDateString('en-US'))
              // let [year, month, day] = newTo.replace(/T.+/, '').replace(/\-/g, "/").split("/")
              // const [yearToNew, monthToNew, dayToNew] = getYearMonthAndDay(`${day}/${month}/${year}`)

              values.fromDate = dateFrom

              values.toDate = datePrueba
            }
            // console.log('values...', values)

            if (!values.isDateSelected) {
              delete values.fromDate
              delete values.toDate
              delete values.isDateSelected
            }

            let params = Object.keys(values).reduce((a, b) => {
              if (values[b]) {
                return [...a, `${b}=${values[b]}`]
              }
              return a
            }, [] as any)
            await onGetMovements(params, 0)
            // setModalSearch(false)
            setShowModal(false)
          }}
        />
      </FloatingForm>

      {/* <ModalSearchDate display={showModal} onClose={() => setShowModal(false)} 
      form={filterForm} onSubmitValues={onSubmitValues} /> */}

      <Modal
        // xlClasses="w-2/5"
        display={showModalAdd}
        onClose={() => setShowModalAdd(false)}
        xlClasses="w-[650px]"
      >
        <IncomeForm
          type={selectedType}
          onClose={() => setShowModalAdd(false)}
          bankOptions={[selectedAccountToTransactions]}
          onSubmit={async (values) => {
            // console.log('values...', values)
            addAlert({
              message: `Creando ${
                selectedType === 'INCOME' ? 'ingreso' : 'egreso'
              }`,
              status: 'loading',
            })
            try {
              await axios.post(
                `${server}/${selectedType === 'INCOME' ? 'income' : 'outflow'}`,
                values
              )
              await onGetMovements([], 0)
              setShowModalAdd(false)
              addAlert({
                message: `${
                  selectedType === 'INCOME' ? 'Ingreso' : 'Egreso'
                } creado satisfactoriamente`,
                status: 'success',
              })
            } catch (err) {
              addAlert({
                message: `Error al crear ${
                  selectedType === 'INCOME' ? 'ingreso' : 'egreso'
                }`,
                status: 'error',
              })
            }
          }}
        />
      </Modal>

      <FloatingForm
        visible={modalSelectAction}
        onClose={() => setModalSelectAction(false)}
        topClass="top-20"
        rightClass="right-10"
        containerClass="w-1/5"
      >
        <Select
          label="Seleccione el tipo de acción"
          defaultValue={options[0]}
          options={options}
          onChange={(value) => value && setSelectedType(value.value)}
        />

        <div className="flex justify-center mt-3">
          <Button
            type="outline"
            classes="w-1/3 mr-3"
            onClick={() => setModalSelectAction(false)}
          >
            Cancelar
          </Button>

          <Button
            classes="w-1/3"
            type="primary"
            onClick={() => setShowModalAdd(true)}
          >
            Aceptar
          </Button>
        </div>
      </FloatingForm>

      <ModalConfirm
        title={`¿Está seguro que desea eliminar este ${
          transacionToDelete?.type === 'income' ? 'ingreso' : 'egreso'
        }?`}
        displayConfirmModal={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        onConfirm={async () => {
          addAlert({
            message: `Eliminando ${
              transacionToDelete.type === 'income' ? 'ingreso' : 'egreso'
            }`,
            status: 'loading',
          })
          try {
            const [paymentType, id] = transacionToDelete?.id?.split('-')
            await axios.delete(
              `${server}/${
                transacionToDelete.type === 'income' ? 'income' : 'outflow'
              }?id=${id}`
            )
            await onGetMovements([], 0)
            addAlert({
              message: `${
                transacionToDelete.type === 'income' ? 'Ingreso' : 'Egreso'
              } eliminado satisfactoriamente`,
              status: 'success',
            })
          } catch (err) {
            addAlert({
              message: `Error al eliminar ${
                transacionToDelete.type === 'income' ? 'ingreso' : 'egreso'
              }`,
              status: 'error',
            })
          } finally {
            setShowConfirmModal(false)
          }
        }}
      />
      <Modal
        xlClasses="w-[650px]"
        display={onShowMovementAction}
        onClose={() => setOnShowMovementAction(false)}
      >
        <IncomeForm
          onClose={() => setOnShowMovementAction(false)}
          onSubmit={async (values) => {
            values.account = {
              id: selectedAccountToTransactions?.id,
              currency: {
                id: selectedAccountToTransactions?.idCurrency
              }
            }

            if (values?.movementType === 'income') {
              values.payer = values.beneficiary
              delete values.beneficiary
            }

            addAlert({
              message: 'Creando Movimiento',
              status: 'loading',
            })
            try {
              await axios.post(
                `${server}/${values?.movementType}`,
                values
              )
              await onGetMovements([], 0)
              addAlert({
                message: 'Movimiento creado satisfactoriamente.',
                status: 'success',
              })
              setOnShowMovementAction(false)
            } catch (err) {
              addAlert({
                message: 'Error al crear movimiento.',
                status: 'error',
              })
            }
            console.log('VALUES....', values)
          }}
          type={'BANK'}
          idCurrency={selectedAccountToTransactions?.idCurrency}
        />
      </Modal>
    </div>
  )
}

interface BalancesProps {
  setHeaderActions: React.Dispatch<React.SetStateAction<HeaderActions | null>>
}

export default Balances
